<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="title">名称</span>
        <el-input
          v-model="parameter.group_name"
          style="width: 200px;"
          placeholder="请输入内容"
        />
      </div>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="search"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button>
      <el-button
        type="success"
        icon="el-icon-circle-plus"
        @click="func"
      >创建</el-button>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="投放组id"
          align="center"
        />
        <el-table-column
          prop="leader_name"
          label="组长"
          align="center"
        />

        <el-table-column
          prop="group_name"
          label="组名"
          align="center"
        />
        <el-table-column
          label="操作"
          align="center"
        >
          <template scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="modify(scope.row)"
            >修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination-right
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <el-dialog
      :title="data.id ? '修改投放组' : '创建投放组'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%"
      @closed="(data.group_name = null),(data.id = null), (data.leader_id = null)"
    >
      <div class="content">
        <div class="item">
          <span class="item_title">投放组名称</span>
          <el-input
            v-model="data.group_name"
            class="item_input"
          />
        </div>
        <div class="item">
          <span class="item_title">组长</span>
          <el-select
            v-model="data.leader_id"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in groupLeaders"
              :key="item.id"
              :label="item.nickname"
              :value="item.id"
            />
          </el-select>
        </div>
      </div>
      <div style="display: flex; margin-top: 30px; justify-content: end;">
        <el-button
          type="primary"
          @click="determine"
        >确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { adbasicreportgroupindex, adbasicreportgroupstore, adbasicreportgroupupdate, launchTeamLeader } from '@/api/hugeAdvertGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        page_size: 10,
        group_name: null
      },
      data: {
        leader_id: null,
        group_name: null,
        id: null
      },
      dialogVisible: false,
      groupLeaders: []
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    async getDataList() {
      this.loading = true
      const data = await adbasicreportgroupindex(this.parameter)
      this.tableData = data.data
      this.loading = false
    },

    // 修改
    async modify(row) {
      this.dialogVisible = true
      const data = await launchTeamLeader()
      // console.log('修改', data, row)
      this.groupLeaders = data.data.user
      this.data.group_name = row.group_name
      this.data.leader_id = row.leader_id
      this.data.id = row.id
    },

    fetchPageSize(s) {
      this.parameter.page_size = s
      this.getDataList()
    },

    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },

    async determine() {
      let text = null
      if (!this.data.group_name || !this.data.leader_id) {
        text = '请填写名称'
      }

      if (!text) {
        this.data.id ? await adbasicreportgroupupdate({ id: this.data.id, leader_id: this.data.leader_id, group_name: this.data.group_name }) : await adbasicreportgroupstore({ ...this.data })
      }

      this.$message({
        message: text ? '请填写名称' : this.data.id ? '更新成功' : '创建成功',
        type: text ? 'warning' : 'success'
      })

      if (!text) {
        this.data.group_name = null
        this.data.leader_id = null
        this.data.id = null
        this.dialogVisible = false
        this.getDataList()
      }
    },

    // 搜索
    search() {
      this.parameter.page = 1
      this.getDataList()
    },

    async func() {
      this.dialogVisible = true
      const data = await launchTeamLeader()
      this.groupLeaders = data.data.user
    },

    // 重置
    reset() {
      this.parameter = {
        page: 1,
        page_size: 10,
        group_name: null
      }
      this.getDataList()
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.selectionArea {
  display: flex;
}

.content {
  .item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .item_title {
      display: inline-block;
      width: 100px;
    }
    .item_input {
      width: 200px;
    }
  }
}

.item {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.title {
  display: inline-block;
  margin-right: 10px;
}
</style>
